import React, { useEffect } from "react";
import LayoutCenter from "../UserInterface/LayoutCenter";
import { CardContainer } from "../UserInterface/CardContainer";
import { useState } from "react";
import UseWindowSize from "../UseWindowSize";

const Pagination = ({ pageNumber, currentPage, winSize, state, setState }) => {
  const handleClick = (event, num) => {
    setState({
      ...state,
      currentPage: Number(num)
    });
    window.scrollTo(0, 0);
  };
  const handlePrev = () => {
    setState({
      ...state,
      currentPage:
        currentPage === pageNumber[0] ? pageNumber[0] : currentPage - 1
    });
    window.scrollTo(0, 0);
  };
  const handleLast = () => {
    setState({
      ...state,
      currentPage: pageNumber.length
    });
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    setState({
      ...state,
      currentPage:
        currentPage === pageNumber.length ? pageNumber.length : currentPage + 1
    });
    window.scrollTo(0, 0);
  };

  const handleFirst = () => {
    setState({
      ...state,
      currentPage: pageNumber[0]
    });
    window.scrollTo(0, 0);
  };

  const showButton = pageNumber.length >= 7 ? "button-next-prev" : "none";

  return (
    <>
      <div className="container-numberPagination">
        <div onClick={() => handleFirst()} className={showButton}>
          &laquo;
        </div>
        <div onClick={() => handlePrev()} className="button-next-prev">
          &lt;
        </div>
        <div className="pagination-container">
          {pageNumber.map((num, index) => {
            return (
              <div
                key={index}
                onClick={(event) => handleClick(event, num)}
                className={
                  (num > pageNumber[currentPage] + (winSize > 600) ? 1 : 0) &&
                    (num < pageNumber.length - (winSize > 600) ? 2 : 0)
                    ? "none"
                    : "number"
                }
                style={{
                  color:
                    currentPage === num
                      ? "var(--color-red)"
                      : "var(--color-black)",
                  display:
                    num < currentPage
                      ? num >= pageNumber.length - 5
                        ? ""
                        : "none"
                      : ""
                }}
              >
                {num}
              </div>
            );
          })}
        </div>
        <div onClick={() => handleNext()} className="button-next-prev">
          &gt;
        </div>
        <div onClick={() => handleLast()} className={showButton}>
          &raquo;
        </div>
      </div>
      <style jsx>{`
        .pagination-container {
          display: flex;
        }
        .container-numberPagination {
          display: flex;
          justify-content: center;
          margin: 50px 0;
        }
        .none {
          display: none;
        }
        .number {
          margin: 16px;
          cursor: pointer;
          color: var(--color-gray);
          font-size: 16px;
          font-weight: 600;
          line-height: 19px;
        }
        .dot {
          margin: 16px 4px;
        }
        .button-next-prev {
          background-color: var(--color-red);
          height: 32px;
          width: 32px;
          margin: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: white;
          border-radius: 8px;
          cursor: pointer;
        }
        @media only screen and (max-width: 600px) {
          .container-numberPagination {
            margin: 20px 0;
          }
        }
      `}</style>
    </>
  );
};
export default Pagination;
